import { useState } from 'react';
import { RevxButton } from 'components/RevxButton';
import { JOB_ADJUSTMENT_WORKSPACE_FILTER } from 'utils/constants';
import {
  JobAdjustmentStatusEnum,
  JobItem,
  JobUIStatusEnum,
} from 'domains/workspaceDomain';
import useJobCardInfo from '../../hooks/useJobCardInfo';
import JobAdjustmentModal from '../../components/JobAdjustmentModal';

const { AWAITING_ACCEPT, AWAITING_APPROVAL } = JobAdjustmentStatusEnum;

type CardActionViewJobAdjustmentBtnProps = {
  data: JobItem;
  filter: JobUIStatusEnum;
  onModalSuccess?: () => void;
};
const CardActionViewJobAdjustmentBtn = ({
  data,
  filter,
  onModalSuccess,
}: CardActionViewJobAdjustmentBtnProps) => {
  const { adjustmentStatus, id } = data;
  const { hasOperator, hasCustomer, hasProxy, hasProducer } =
    useJobCardInfo(data);
  const [modalVisible, setModalVisible] = useState<boolean>(false);

  const reviewText = 'Review Job Adjustment';
  const viewText = 'View Job Adjustment';
  const btnText = () => {
    if (adjustmentStatus === AWAITING_APPROVAL) {
      if (hasOperator) return reviewText;
      if (hasProducer) return viewText;
    }
    if (adjustmentStatus === AWAITING_ACCEPT) {
      if (hasOperator) return viewText;
      if (hasCustomer || hasProxy) return reviewText;
    }
    return null;
  };

  const handleClick = () => {
    localStorage.setItem(JOB_ADJUSTMENT_WORKSPACE_FILTER, filter);
    setModalVisible(true);
  };

  const handleModalSuccess = async () => {
    console.log(
      'Modal success handler called in CardActionViewJobAdjustmentBtn'
    );
    try {
      if (onModalSuccess) {
        console.log('Calling onModalSuccess callback');
        await onModalSuccess();
        console.log('onModalSuccess callback completed successfully');
      } else {
        console.log('No onModalSuccess callback provided');
      }
    } catch (error) {
      console.error('Error in modal success handler:', error);
    } finally {
      console.log('Modal success handler finished');
    }
  };

  return (
    <>
      {btnText() && (
        <RevxButton
          type="primary"
          brandOrange
          style={{
            width: '280px',
          }}
          onClick={handleClick}
        >
          {btnText()}
        </RevxButton>
      )}
      <JobAdjustmentModal
        visible={modalVisible}
        jobId={id}
        onCancel={() => setModalVisible(false)}
        onSuccess={handleModalSuccess}
      />
    </>
  );
};

export default CardActionViewJobAdjustmentBtn;
